<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-5">
        The goal of this experiment is to separate a mixture of two unknown compounds into
        individual components and to identify the compounds. Answer the given questions. More than
        one answer may be possible.
      </p>

      <p class="mb-2">
        Why does one need to be especially careful when working with diethyl ether?
      </p>

      <p v-for="option in optionsShuffled" :key="option.value" class="mb-0 mt-0">
        <v-checkbox v-model="inputs.studentAnswers" :value="option.value" class="ml-6 mb-n4 mt-0">
          <template v-slot:label>
            <stemble-latex :content="option.text" />
          </template>
        </v-checkbox>
      </p>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';
import STextarea from '@/common/components/STextarea.vue';
import {seededShuffle} from '@/courses/utils/seededShuffle';

export default {
  name: 'ChemUCI51LB_A8Q1A',
  components: {StembleLatex, STextarea},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        studentAnswers: [],
      },
      options: [
        {text: 'Because it is extremely volatile and flammable.', value: 'volatile'},
        {
          text: 'Fumes can cause drowsiness and dizziness, and in high concentration, loss of consciousness.',
          value: 'fumes',
        },
        {text: 'Because it is highly acidic and can burn the skin.', value: 'acidic'},
      ],
    };
  },
  computed: {
    seed() {
      return this.$inertia.getSeed();
    },
    optionsShuffled() {
      return seededShuffle(this.options, this.seed);
    },
  },
};
</script>
